import { handleResponse, Headers } from '../_helpers';

export const MarkerTemplatesService = {
  fetchWorldTemplates,
  fetchTemplate,
  saveTemplate,
  createTemplate,
  deleteTemplate,
};

function fetchWorldTemplates(worldID) {
  const request = {
    method: 'GET',
    headers: Headers.set(),
  };

  return fetch(
    `${process.env.API_URL}/api/v1/markers/templates/world/${worldID}`,
    request
  )
    .then(handleResponse)
    .then((templates) => templates);
}

function fetchTemplate(templateID) {
  const request = {
    method: 'GET',
    headers: Headers.set(),
  };

  return fetch(
    `${process.env.API_URL}/api/v1/markers/templates/${templateID}`,
    request
  )
    .then(handleResponse)
    .then((template) => template);
}

function saveTemplate(templateID, templateData) {
  const request = {
    method: 'POST',
    headers: Headers.set(),
    body: JSON.stringify({ template: templateData }),
  };

  return fetch(
    `${process.env.API_URL}/api/v1/markers/templates/${templateID}`,
    request
  )
    .then(handleResponse)
    .then((template) => template);
}

function createTemplate(templateData) {
  const request = {
    method: 'POST',
    headers: Headers.set(),
    body: JSON.stringify({ template: templateData }),
  };

  return fetch(`${process.env.API_URL}/api/v1/markers/templates/new`, request)
    .then(handleResponse)
    .then((template) => template);
}

function deleteTemplate(templateID) {
  const request = {
    method: 'DELETE',
    headers: Headers.set(),
  };

  return fetch(
    `${process.env.API_URL}/api/v1/markers/templates/${templateID}`,
    request
  )
    .then(handleResponse)
    .then(() => templateID);
}
